import { render } from "./JobList.vue?vue&type=template&id=06a20c15&scoped=true"
import script from "./JobList.vue?vue&type=script&lang=js"
export * from "./JobList.vue?vue&type=script&lang=js"

import "./JobList.vue?vue&type=style&index=0&id=06a20c15&scoped=true&lang=css"

import exportComponent from "/usr/frontend/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06a20c15"]])

export default __exports__